import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-joblist-mobile',
  templateUrl: './joblist-mobile.page.html',
  styleUrls: ['./joblist-mobile.page.scss'],
})
export class JoblistMobilePage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
